import axios from "../axios";

// Get all safety checkpoints
export const getHseSafetyCheckpoints = async (params = {}) => {
  const response = await axios.get("/hse_safety_checkpoints", { params });
  return response;
};

// Get a single safety checkpoint
export const getHseSafetyCheckpoint = async (id) => {
  const response = await axios.get(`/hse_safety_checkpoints/${id}`);
  return response;
};

// Create a new safety checkpoint
export const createHseSafetyCheckpoint = async (data) => {
  const response = await axios.post("/hse_safety_checkpoints", {
    hse_safety_checkpoint: data,
  });
  return response;
};

// Update a safety checkpoint
export const updateHseSafetyCheckpoint = async (id, data) => {
  const response = await axios.put(`/hse_safety_checkpoints/${id}`, {
    hse_safety_checkpoint: data,
  });
  return response;
};

// Delete a safety checkpoint
export const deleteHseSafetyCheckpoint = async (id) => {
  const response = await axios.delete(`/hse_safety_checkpoints/${id}`);
  return response;
};

// Bulk create checkpoints
export const bulkCreateHseSafetyCheckpoints = async (checkpoints) => {
  const response = await axios.post("/hse_safety_checkpoints/bulk_create", {
    checkpoints,
  });
  return response;
};
